import { useState } from 'react';
import { Button, Typography } from "@mui/material";
import { useDialog } from '../components/Dialog'
import { DeleteForever } from '@mui/icons-material';
import { fetchJSON, useRefresh } from '../data/fetch';
import { TrackingButton } from './GLSDisplay';


export function DPDLabelButton({ d }) {
  let { dpd } = d;
  if (!dpd || !dpd.pdf) return null;
  return <Button href={`/json/delivery/dpd/labels/${d.id}`} target="dpdlabels">Nyomtatás</Button>;
}


export function DPDFunctions({ d }) {
  let refresh = useRefresh();
  let [loading, setLoading] = useState(false);
  let { trackingnr, dpd, asset, statusenum } = d;
  let { setDialog } = useDialog();
  if ((asset !== "DPD" && asset !== "DPD Utánvét") || !statusenum || statusenum == 10) {
    return null;
  }

  const printDPD = async (options) => {
    setLoading(true);
    let ret = await fetchJSON('POST', '/delivery/dpd/print/' + d.id, options);
    if (ret.error) {
      alert(ret.error);
    } else {
      window.open('/json/delivery/dpd/labels/' + d.id, '_blank');
    }
    setLoading(false);
    refresh();
  }

  const prepareDPD = async () => {
    setLoading(true);
    let ret = await fetchJSON('POST', '/delivery/dpd/prepare/' + d.id);
    if (ret.error) {
      alert(ret.error);
    }
    setLoading(false);
    refresh();
  }

  const setTrackingNr = () => {
    setDialog({ id: 'trackingnr', rec: d });
  }

  if (trackingnr) {
    return <div>
      <Typography variant="body2">Trackingnr: {trackingnr}</Typography>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <TrackingButton d={d} />
        <DPDLabelButton d={d} />
        <Button startIcon={<DeleteForever />} onClick={() => setDialog({ id: 'deleteDPD', rec: d })}>Törlés</Button>
      </div>
    </div>
  }

  if (dpd) {
    return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div>Előkészítve: {dpd.id.join(', ')}</div>
      <Button variant="outlined" disabled={loading} onClick={setTrackingNr}>Manuális</Button>
    </div>
  }

  return <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    <Button variant="contained" color="primary" disabled={loading} onClick={() => printDPD({ thermo: false })}>Nyomtat</Button>
    <Button variant="outlined" color="secondary" disabled={loading} onClick={prepareDPD}>Előkészít</Button>
    <Button variant="outlined" disabled={loading} onClick={setTrackingNr}>Kézi</Button>
  </div>
}
